import React, {Component} from 'react';
import SubListAddress from './SubListAddress/SubListAddress'

import './SearchAdress.css'

class SearchAdress extends Component {
    state = {};

    render() {
        return (
            <div className={this.props.divClassProps}>
                <div className={this.props.boxClassProps}>
                    <input type="text"
                           name='searchAddressInput'
                           className={this.props.inputClassProps}
                           value={this.props.addressProps}
                           onChange={this.props.handleChangeFuncProps}
                           onClick={this.props.showSubListAddressFunc}
                           placeholder="Найти на карте"/>
                    {this.props.showSubListAddress && <SubListAddress addressArrProps={this.props.addressArrProps}
                                    chooseAddressFuncProps={this.props.chooseAddressFuncProps}
                    />}
                </div>
            </div>
        )
    }
}

export default SearchAdress;